import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const RotatingTextRoot = superstyled({
  name: 'RotatingText',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['animation', 'animationDuration', 'isVisible'],
  styles: ({ animationDuration, isVisible }) => {
    return {
      opacity: isVisible ? 1 : 0,
      transition: `opacity ${animationDuration}ms ease-in-out`,
      display: 'block'
    };
  }
});

export const RotatingTextText = superstyled({
  name: 'RotatingText',
  slot: 'Text',
  tag: Text
});
